import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { ArrayType } from '@angular/compiler';
import { BehaviorSubject } from 'rxjs';
import {environment} from "../../../../../../environments/environment";




@Component({
  selector: 'app-occupations-suggest',
  templateUrl: './occupations-suggest.component.html',
  styleUrls: ['./occupations-suggest.component.css']
})

export class OccupationsSuggestComponent implements OnInit {
  _transformer: any;
  sugerencias: Array<string>
  total: any;


  constructor(
    private http: HttpClient,



  ) {
   }

  ngOnInit() {


  }


 public searchSuggest(event) {
   console.log(event.target.value);
   //const term = event.target.value;
   const term = event.target.value;
   // this.getSearchSuggest(event.target.value).then(result=> {
   //   console.log(result);
   //
   // })
   this.getOccupation(term).then(result=> {
        console.log(result);
        this.sugerencias=result;
        this.total=result.length
     })




 }





  getSearchSuggest(term: string): Promise<any> {
    return this.http.get('https://ec.europa.eu/esco/portal/concept/suggest/occupations?conceptLanguage=es&full=false&term='+term).toPromise();
  }

  getOccupation(term):Promise<any> {
    return this.http.get(environment.apiUrl+'/searchoccupation?occupation='+term).toPromise();

  }


}
